class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }
}

customElements.define('quantity-input', QuantityInput)

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  )

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector('details')
    const summaryElements = this.querySelectorAll('summary')
    const collectionFilterOverlay = document.querySelector('.collection-filters__overlay')
    this.addAccessibilityAttributes(summaryElements)
    this.submitButton = this.querySelector('button[type="submit"]');

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      )

    this.submitButton?.addEventListener('click', (event) => {
      this.closeMenuDrawer(event)
    });
    this.addEventListener('keyup', this.onKeyUp.bind(this))

    if (collectionFilterOverlay) collectionFilterOverlay.addEventListener('click', (e) => this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')))

    // this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()

    this.navMobileOverlay = this.querySelector('.js-mobile-overlay');
    if ( this.navMobileOverlay ) {
      this.navMobileOverlay.addEventListener('click', (e) => {
        this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'));
      })
    }
  }

  bindEvents() {
    this.querySelectorAll('summary:not(.filter-accordion)').forEach((summary) =>
      summary.addEventListener('click', this.debouncedOnSubmit.bind(this))
    )
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    )
  }

  debouncedOnSubmit(event){
   debounce( this.onSummaryClick(event), 1000)
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute('role', 'button')
      element.setAttribute('aria-expanded', false)
      element.setAttribute('aria-controls', element.nextElementSibling.id)
    })
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElements = document.querySelectorAll('.js-filter-drawer summary[data-text]')
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const isOpen = detailsElement.hasAttribute('open')

    summaryElements.forEach((element) => {
      if (element == event.target) return
      this.closeOtherDrawer(element)
    })

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement)
    } else {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      )

      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
      })
    }
  }

  closeOtherDrawer(summaryElement) {
    const detailsToggle = summaryElement.closest('details')
    detailsToggle.classList.remove('menu-opening')
    detailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open')
      details.classList.remove('menu-opening')
    })
    detailsToggle
      .querySelector('summary')
      .setAttribute('aria-expanded', false)
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    )
    removeTrapFocus(false)
    this.closeAnimation(detailsToggle)
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening')
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open')
        details.classList.remove('menu-opening')
      })
      this.mainDetailsToggle
        .querySelector('summary')
        .setAttribute('aria-expanded', false)
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      )
      removeTrapFocus(elementToFocus)
      this.closeAnimation(this.mainDetailsToggle)
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement) &&
        this.classList.contains('js-filter-drawer')
      ) {
        this.closeMenuDrawer(event)
      }
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening')
    removeTrapFocus()
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 1000) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          )
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

class Collection {
  static observer = null;
  static isSubmenu = false;

  static addImagesObserver() {

    let isCardAnimating = false
    const gridItems = Array.from(document.querySelectorAll('.grid__item'));
    const gridItemImages = [];
    gridItems.forEach(item => {
      if (item.querySelector('img')) {
        gridItemImages.push(item.querySelector('img'));
      }
      if (item.querySelector('video-wrapper')) {
        gridItemImages.push(item.querySelector('video-wrapper'));
      }
    })

    const showCardInSequence = () => {
      isCardAnimating = true
      let counter = 1
      let intersectedHidden = document.querySelectorAll('.is-intersected:not(.is-visible)')

      if (!intersectedHidden.length) {
        isCardAnimating = false
        return
      }

      intersectedHidden.forEach((el, i) => {
        setTimeout(() => {
          el.classList.add('is-visible');

          if (i + 1 === intersectedHidden.length) {
            isCardAnimating = false
          }
        }, counter * 300);
        counter++;
      })
    }

    const showPreviousProducts = (visibleIndex) => {
      for (let i = 0; i <= visibleIndex; i++) {
        gridItems[i].classList.add('is-intersected', 'is-visible')
      }
    }

    if ( Collection.observer ){
      Collection.observer.disconnect()
    }

    Collection.observer = new IntersectionObserver(entries => {

      // On desktop, the featured product cards display first in the row (due to CSS grid positioning), but they come later in the DOM order. 
      // To make them animate in in the correct order, let's move them to the front of the IO entries.
      entries.sort((entryA)=> {
        return entryA.target.closest(".grid__item--featured") ? -1 : 0;
      })

      entries.forEach((entry, index)=> {
        if (entry.isIntersecting && !entry.target.closest('.grid__item').classList.contains('is-intersected')) {
          entry.target.closest('.grid__item').classList.add('is-intersected');

          if (index === 0) {
            const visibleProductIndex = gridItems.findIndex(product => product === entry.target.closest('.grid__item'))
            showPreviousProducts(visibleProductIndex)
          }
        } else if(entry.target.closest('.grid__item').classList.contains('is-intersected')) {
          if (!Collection.isSubmenu){
            entry.target.closest('.grid__item').classList.add('is-visible')
          }
          showCardInSequence()
        }
      })

      if (!isCardAnimating) {
        showCardInSequence()
      }
    }, {
      root: null,
      rootMargin: "-100px"
    })

    document.addEventListener('scroll', () => {
      if (!isCardAnimating) {
        showCardInSequence()
      }
    })

    gridItemImages.forEach(image => {
      Collection.observer.observe(image)
    })
  }

  static setSubmenu(value = false){
    Collection.isSubmenu = value
  }
}

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super()
    // this.navMobileOverlay = this.querySelector('.js-mobile-overlay');
    // this.navMobileOverlay.addEventListener('click', (e) => {
    //   console.log('hide w');
    //   this.closeMenuDrawer();
    // })

    const detailsParentEl = this.querySelectorAll('.js-menu-draw__details-parent')
    const detailsChildEl = this.querySelectorAll('.js-menu-draw__details-child')
    this.handleSingleOpenDetails(detailsParentEl)
    this.handleSingleOpenDetails(detailsChildEl)
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header')
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0

    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    )

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })

    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  handleSingleOpenDetails(details) {
    details.forEach((targetDetail) => {
      targetDetail.addEventListener('click', () => {
        const openedDetails = [...details].filter(item => item.hasAttribute('open'))
        openedDetails.forEach((detail) => {
          if (detail !== targetDetail) detail.removeAttribute('open')
        })
      })
    })
  }
}

customElements.define('header-drawer', HeaderDrawer)

class ModalDialog extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    )
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide()
    })
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide()
    })
  }

  show(opener) {
    this.openedBy = opener
    document.body.classList.add('overflow-hidden')
    this.setAttribute('open', '')
    this.querySelector('.template-popup')?.loadContent()
    trapFocus(this, this.querySelector('[role="dialog"]'))
  }

  hide() {
    document.body.classList.remove('overflow-hidden')
    this.removeAttribute('open')
    removeTrapFocus(this.openedBy)
    window.pauseAllMedia()
  }
}
customElements.define('modal-dialog', ModalDialog)

class ModalOpener extends HTMLElement {
  constructor() {
    super()

    const button = this.querySelector('button')
    button?.addEventListener('click', () => {
      document.querySelector(this.getAttribute('data-modal'))?.show(button)
    })
  }
}
customElements.define('modal-opener', ModalOpener)

class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      'click',
      this.loadContent.bind(this)
    )
  }

  loadContent() {
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )

      this.setAttribute('loaded', true)
      window.pauseAllMedia()
      this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      ).focus()
    }
  }
}

customElements.define('deferred-media', DeferredMedia)

class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.el = this.querySelector('details');
    this.summary = this.el.querySelector('summary');
    this.content = this.el.querySelector('[accordion-answer]');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.duration = 200;
    this.oneOpen = true;

    const accordion = new AccordionGlobals();
    this.summary.addEventListener('click', (e) => accordion.onClick(e, this));
  }
}

customElements.define('accordion-item', AccordionItem);


// Check page uses mouse or tab
document.body.addEventListener('keydown', function(e) {
  if (e.keyCode === 9) {
    document.body.classList.add('using-tab');
  }
});

document.body.addEventListener('mousedown', function() {
  if( document.body.classList.contains('using-tab') ) {
    document.body.classList.remove('using-tab');
  }
});

// set height
function setViewport () {
  const vw = window.innerWidth * 0.01;
  const vh = window.innerHeight * 0.01;

  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--ratio', `${vw / vh}`);
}

setViewport();

let r = document.querySelector(':root');
r.style.setProperty('--height', window.innerHeight + 'px');
window.addEventListener('resize', function() {
  if (window.innerWidth < 990) { return; }
  r.style.setProperty('--height', window.innerHeight + 'px');
  setViewport()
});

class FocusingButton extends HTMLButtonElement {
  constructor() {
    super();
    this.el = this;
    this.el.addEventListener('focusin', (e) => this.focusIn());
    this.el.addEventListener('focusout', (e) => this.focusOut());
  }
  focusIn() {
    this.el.closest('.card-wrapper').classList.add('focused');
  }
  focusOut() {
    this.el.closest('.card-wrapper').classList.remove('focused');
  }
}
customElements.define('product-form-button', FocusingButton, { extends: 'button'});

class SignupModal {
  constructor() {
    this.targetNode = document.body;
    this.active = false;
    this.config = {
      attributes: true,
      childList: true,
      characterData: true
    };
    this.observerCallback = mutations => {
      mutations.forEach(mutation => {
        if (window.matchMedia('(max-width: 989px)').matches) {
          mutation.addedNodes.forEach(node => {
            if (node.firstChild && node.firstChild.nodeType === 1 && node.firstChild.classList.contains('kl-private-reset-css-Xuajs1')) {
              this.targetNode.classList.add('scroll-lock');
              node.setAttribute('signup-modal', '');
              this.active = true;
            }
          });
          mutation.removedNodes.forEach(node => {
            if(node.hasAttribute('signup-modal')) {
              this.targetNode.classList.remove('scroll-lock');
              this.active = false;
            }
          });
        } else {
          mutation.addedNodes.forEach(node => {
            if (node.firstChild && node.firstChild.nodeType === 1 && node.firstChild.classList.contains('kl-private-reset-css-Xuajs1')) {
              node.setAttribute('signup-modal', '');
              setTimeout(() => {
                this.closeBtn = document.querySelector('body > div > div .needsclick:has(button) button.needsclick.kl-private-reset-css-Xuajs1:has(#close-form-3)');
                this.form = document.querySelector('body > div > div .needsclick:has(button) form.needsclick.kl-private-reset-css-Xuajs1');
                this.arrow = document.querySelector('body>div>div .needsclick:has(button) .needsclick.kl-private-reset-css-Xuajs1[data-testid=form-row]:last-child>div:last-child button');

                this.form.focus();
                this.form.addEventListener('submit', () => {
                  this.closeBtn.focus();
                });
                this.arrow.addEventListener('keyup', (e) => {
                  if (e.key === "Enter") {
                    this.closeBtn.focus();
                  }
                });
              }, 500)
            }
          });
        }
      })
    }

    this.observer();
  }

  observer() {
    const observer = new MutationObserver(this.observerCallback);
    observer.observe(this.targetNode, this.config);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.add('animated-in')

  const sections = Array.from( document.querySelectorAll('[data-animate-fade-in]'))

  const observerOptions = {
    root: null,
    threshold: 0,
    rootMargin: '0px 0px -50px 0px',
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('animated-in')
          observer.unobserve(entry.target)
        }, 250);
      }
    })
  }, observerOptions)

  for (let section of sections) {
    observer.observe(section);
  }
})

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };

    if (!!this.elements.button) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    }

    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);
